// Cara Ldn mobile drawer menu: tabs + accordions. Added by Claude, reversible.
if (!customElements.get('cara-drawer-menu')) {
  customElements.define('cara-drawer-menu', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((t) => {
        t.addEventListener('click', () => this.select(t.dataset.tab));
        t.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          const i = this.tabs.indexOf(t);
          const next = this.tabs[(i + (e.key === 'ArrowRight' ? 1 : this.tabs.length - 1)) % this.tabs.length];
          this.select(next.dataset.tab);
          next.focus();
        });
      });
      this.querySelectorAll('.cdm__cat-btn').forEach((b) => {
        this.setLinksFocusable(b, false);
        b.addEventListener('click', () => {
          const open = b.getAttribute('aria-expanded') !== 'true';
          b.setAttribute('aria-expanded', String(open));
          this.setLinksFocusable(b, open);
        });
      });
    }
    setLinksFocusable(btn, on) {
      btn.nextElementSibling?.querySelectorAll('a').forEach((a) => (on ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1')));
    }
    select(g) {
      this.tabs.forEach((t) => {
        const on = t.dataset.tab === g;
        t.setAttribute('aria-selected', String(on));
        on ? t.removeAttribute('tabindex') : t.setAttribute('tabindex', '-1');
      });
      this.querySelectorAll('[role="tabpanel"]').forEach((p) => (p.hidden = p.id !== `CdmPanel-${g}`));
    }
  });
}
